<template>
    <div class="container">
        <el-row class="mb20">
            <h1>今日实时数据 <span>{{hourData.updateTime}}更新</span></h1>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">营业额</div>
                        <div class="number">
                            ¥{{hourData.saleAmount}}<span v-if="hourData.saleAmountDecimal" class="f20">.{{hourData.saleAmountDecimal}}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">收入</div>
                        <div class="number">
                            ¥{{hourData.incomeAmount}}<span v-if="hourData.incomeAmountDecimal" class="f20">.{{hourData.incomeAmountDecimal}}</span>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">订单总数</div>
                        <div class="number">{{hourData.totalOrderCount}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">外卖订单</div>
                        <div class="number">{{hourData.takeawayOrderedCount}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">自提订单</div>
                        <div class="number">{{hourData.pickUpOrderCount}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">堂食订单</div>
                        <div class="number">{{hourData.dineInOrderCount}}</div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">下单人数</div>
                        <div class="number">{{hourData.orderCount}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">下单转化率</div>
                        <div class="number">
                            {{hourData.orderCountPercentage==0?0:((hourData.orderCountPercentage)*100).toFixed(2)+'%'}}
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">曝光人数</div>
                        <div class="number">{{hourData.viewCount}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">入店人数</div>
                        <div class="number">{{hourData.enterCount}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="card">
                    <div class="pl24 pt20 pb10">
                        <div class="tag-name">入店转化率</div>
                        <div class="number">
                            {{hourData.viewShopPercentage==0?0:((hourData.viewShopPercentage)*100).toFixed(2)+'%'}}
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row class="mb20">
            <h1>历史数据概览</h1>
        </el-row>
        <div v-loading="loading">
            <el-row>
                <div class="card">
                    <div class="pl24 pb10 pt10">
                        <span class="tag-name cursor c6"
                              v-for="(item,index) in timeTabList"
                              :class="{'checked': item.checked}"
                              @click="getHistoryData(item.id,index)">{{item.label}}</span>
                        <!--<span class="tag-name c6">近7天</span>-->
                        <!--<span class="tag-name c6">近30天</span>-->
                        <!--<span class="tag-name c6">按周</span>-->
                        <!--<span class="tag-name c6">按月</span>-->
                        <el-popover
                                placement="right"
                                width="300"
                                v-model="popoverVisible"
                                trigger="click">
                            <el-date-picker
                                v-model="selectMonth"
                                type="month"
                                size="small"
                                value-format="yyyy-MM"
                                placeholder="选择月">
                            </el-date-picker>
                            <el-button type="primary" size="mini" @click="getMonth()">确定</el-button>
                            <span slot="reference" class="tag-name c6 cursor" :class="{'checked': isMonthChecked}">按月</span>
                        </el-popover>
                        <el-popover
                                placement="right"
                                width="420"
                                v-model="popoverVisible1"
                                trigger="click">
                            <el-date-picker
                                    v-model="selectDate"
                                    type="daterange"
                                    size="small"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                            <el-button type="primary" size="mini" @click="getDate()">确定</el-button>
                            <span slot="reference" class="tag-name c6 cursor" :class="{'checked': isDateChecked}">自定义</span>
                        </el-popover>
                        <!--<span class="tag-name c6 cursor">自定义</span>-->
                    </div>
                </div>
            </el-row>
            <el-row class="mb20"><span class="pl24 c6">已选时间：{{startDate}}至{{endDate}}</span></el-row>
            <el-row>
                <div class="card">
                    <div class="card-name">营业分析</div>
                    <ul>
                        <li>
                            <div class="tag-name">营业额</div>
                            <div class="number">
                                ¥{{businessDetail.saleAmount}}<span v-if="businessDetail.saleAmountDecimal" class="f20">.{{businessDetail.saleAmountDecimal}}</span>
                            </div>
                            <div class="c7">
                                {{tabName}}
                                {{getValue(businessDetail.saleAmount,businessDetail.saleAmountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.saleAmount)-(businessDetail.saleAmountCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.saleAmount)-(businessDetail.saleAmountCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">收入</div>
                            <div class="number">
                                ¥{{businessDetail.incomeAmount}}<span v-if="businessDetail.incomeAmountDecimal" class="f20">.{{businessDetail.incomeAmountDecimal}}</span>
                            </div>
                            <div class="c7">
                                {{tabName}}
                                {{getValue(businessDetail.incomeAmount,businessDetail.incomeAmountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.incomeAmount)-(businessDetail.incomeAmountCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.incomeAmount)-(businessDetail.incomeAmountCompare) < 0"></span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">客单价</div>
                            <div class="number">
                                ¥{{businessDetail.averageSinglePerson}}<span v-if="businessDetail.averageSinglePersonDecimal" class="f20">.{{businessDetail.averageSinglePersonDecimal}}</span>
                                <!--{{businessDetail.averageSinglePerson}}-->
                            </div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.averageSinglePersonCompare}}-->
                                {{getValue(businessDetail.averageSinglePerson,businessDetail.averageSinglePersonCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.averageSinglePerson)-(businessDetail.averageSinglePersonCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.averageSinglePerson)-(businessDetail.averageSinglePersonCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">订单总数</div>
                            <div class="number">{{businessDetail.totalOrderCount}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.totalOrderCountCompare}}-->
                                {{getValue(businessDetail.totalOrderCount,businessDetail.totalOrderCountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.totalOrderCount)-(businessDetail.totalOrderCountCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.totalOrderCount)-(businessDetail.totalOrderCountCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">外卖订单</div>
                            <div class="number">{{businessDetail.takeawayOrderedCount}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.takeawayOrderedCountCompare}}-->
                                {{getValue(businessDetail.takeawayOrderedCount,businessDetail.takeawayOrderedCountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.takeawayOrderedCount)-(businessDetail.takeawayOrderedCountCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.takeawayOrderedCount)-(businessDetail.takeawayOrderedCountCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">自提订单</div>
                            <div class="number">{{businessDetail.pickUpOrderCount}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.pickUpOrderCountCompare}}-->
                                {{getValue(businessDetail.pickUpOrderCount,businessDetail.pickUpOrderCountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.pickUpOrderCount)-(businessDetail.pickUpOrderCountCompare) > 0"></span>
                                <span class="arrow-down" v-else-if="(businessDetail.pickUpOrderCount)-(businessDetail.pickUpOrderCountCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">堂食订单</div>
                            <div class="number">{{businessDetail.dineInOrderCount}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.dineInOrderCountCompare}}-->
                                {{getValue(businessDetail.dineInOrderCount,businessDetail.dineInOrderCountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.dineInOrderCount)-(businessDetail.dineInOrderCountCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.dineInOrderCount)-(businessDetail.dineInOrderCountCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </el-row>
            <el-row>
                <div class="card">
                    <div class="card-name">顾客分析</div>
                    <ul>
                        <li>
                            <div class="tag-name">新客人数</div>
                            <div class="number">{{businessDetail.newCustomerCount}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.newCustomerCountCompare}}-->
                                {{getValue(businessDetail.newCustomerCount,businessDetail.newCustomerCountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.newCustomerCount)-(businessDetail.newCustomerCountCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.newCustomerCount)-(businessDetail.newCustomerCountCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">新客占比</div>
                            <div class="number">{{businessDetail.newCustomerPercentage==0?0:((businessDetail.newCustomerPercentage)*100).toFixed(2)+'%'}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.newCustomerPercentageCompare}}-->
                                {{((getValue(businessDetail.newCustomerPercentage,businessDetail.newCustomerPercentageCompare))*100).toFixed(0)}}%
                                <span class="arrow-up" v-if="(businessDetail.newCustomerPercentage)-(businessDetail.newCustomerPercentageCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.newCustomerPercentage)-(businessDetail.newCustomerPercentageCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">复购人数</div>
                            <div class="number">{{businessDetail.repurchaseCount}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.repurchaseCountCompare}}-->
                                {{getValue(businessDetail.repurchaseCount,businessDetail.repurchaseCountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.repurchaseCount)-(businessDetail.repurchaseCountCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.repurchaseCount)-(businessDetail.repurchaseCountCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">复购率</div>
                            <div class="number">{{businessDetail.repurchasePercentage==0?0:((businessDetail.repurchasePercentage)*100).toFixed(2)+'%'}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.repurchasePercentageCompare}}-->
                                {{((getValue(businessDetail.repurchasePercentage,businessDetail.repurchasePercentageCompare))*100).toFixed(0)}}%
                                <span class="arrow-up" v-if="(businessDetail.repurchasePercentage)-(businessDetail.repurchasePercentageCompare) > 0">️</span>
                                <span class="arrow-down" v-else-if="(businessDetail.repurchasePercentage)-(businessDetail.repurchasePercentageCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                        <li>
                            <div class="tag-name">总下单人数</div>
                            <div class="number">{{businessDetail.totalPurchaseCount}}</div>
                            <div class="c7">
                                {{tabName}}
                                <!--{{businessDetail.totalPurchaseCountCompare}}-->
                                {{getValue(businessDetail.totalPurchaseCount,businessDetail.totalPurchaseCountCompare)}}
                                <span class="arrow-up" v-if="(businessDetail.totalPurchaseCount)-(businessDetail.totalPurchaseCountCompare) > 0"></span>
                                <span class="arrow-down" v-else-if="(businessDetail.totalPurchaseCount)-(businessDetail.totalPurchaseCountCompare) < 0">️</span>
                                <span v-else>持平</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="14">
                    <div class="card" style="min-height: 500px;">
                        <div class="card-name">流量分析</div>
                        <ul>
                            <li>
                                <div class="tag-name">曝光人数</div>
                                <div class="number">{{viewDetail.viewCount}}</div>
                                <div class="c7">
                                    {{tabName}}
                                    {{getValue(viewDetail.viewCount,viewDetail.viewCountCompare)}}
                                    <span class="arrow-up" v-if="(viewDetail.viewCount)-(viewDetail.viewCountCompare) > 0">️</span>
                                    <span class="arrow-down" v-else-if="(viewDetail.viewCount)-(viewDetail.viewCountCompare) < 0">️</span>
                                    <span v-else>持平</span>
                                </div>
                            </li>
                            <li>
                                <div class="tag-name">入店转化率</div>
                                <div class="number">{{viewDetail.convertInShop==0?0:((viewDetail.convertInShop)*100).toFixed(2)+'%'}}</div>
                                <div class="c7">
                                    {{tabName}}
                                    <!--{{viewDetail.convertInShopCompare}}-->
                                    {{((getValue(viewDetail.convertInShop,viewDetail.convertInShopCompare))*100).toFixed(0)}}%
                                    <span class="arrow-up" v-if="(viewDetail.convertInShop)-(viewDetail.convertInShopCompare) > 0">️</span>
                                    <span class="arrow-down" v-else-if="(viewDetail.convertInShop)-(viewDetail.convertInShopCompare) < 0">️</span>
                                    <span v-else>持平</span>
                                </div>
                            </li>
                            <li>
                                <div class="tag-name">下单转化率</div>
                                <div class="number">{{viewDetail.convertInOrder==0?0:((viewDetail.convertInOrder)*100).toFixed(2)+'%'}}</div>
                                <div class="c7">
                                    {{tabName}}
                                    <!--{{viewDetail.convertInOrderCompare}}-->
                                    <span v-if="(viewDetail.convertInOrder)-(viewDetail.convertInOrderCompare) != 0">{{((getValue(viewDetail.convertInOrder,viewDetail.convertInOrderCompare))*100).toFixed(0)}}%</span>

                                    <span class="arrow-up" v-if="(viewDetail.convertInOrder)-(viewDetail.convertInOrderCompare) > 0">️</span>
                                    <span class="arrow-down" v-else-if="(viewDetail.convertInOrder)-(viewDetail.convertInOrderCompare) < 0">️</span>
                                    <span v-else>持平</span>
                                </div>
                            </li>
                        </ul>
                        <el-table
                                class="bi-table"
                                :data="viewDetail.viewCountDetail"
                                style="width: 100%;padding: 0 24px 24px">
                            <el-table-column
                                    prop="clientType"
                                    label="客户端类型">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.clientType==0">APP</span>
                                    <span v-else-if="scope.row.clientType==1">微信公众号</span>
                                    <span v-else-if="scope.row.clientType==2">微信小程序</span>
                                    <span v-else-if="scope.row.clientType==3">支付宝小程序</span>
                                    <!--<span v-else-if="scope.row.clientType==4">云闪付小程序</span>-->
                                    <!--<span v-else-if="scope.row.clientType==5">其他</span>-->
                                    <span v-else-if="scope.row.clientType==999">其他</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="viewCount"
                                    width="100"
                                    label="曝光人数">
                            </el-table-column>
                            <el-table-column
                                    width="100"
                                    prop="enterCount"
                                    label="入店人数">
                            </el-table-column>
                            <el-table-column
                                    prop="viewShopPercentage"
                                    label="入店转化率">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.viewShopPercentage > 0">{{((scope.row.viewShopPercentage)*100).toFixed(2)}}%</span>
                                    <span v-else>{{scope.row.viewShopPercentage}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    width="100"
                                    prop="orderCount"
                                    label="下单人数">
                            </el-table-column>
                            <el-table-column
                                    prop="orderCountPercentage"
                                    label="下单转化率">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.orderCountPercentage > 0">{{((scope.row.orderCountPercentage)*100).toFixed(2)}}%</span>
                                    <span v-else>{{scope.row.orderCountPercentage}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="10">
                    <div class="card" style="min-height: 500px;">
                        <div class="card-name">学校排名</div>
                        <el-table
                                class="bi-table table2"
                                :data="schoolRanking.schoolRankingInfos"
                                style="width: 100%;padding: 24px 24px 0 24px;height: 430px;">
                            <el-table-column
                                    width="60"
                                    prop="ranking"
                                    label="排名">
                            </el-table-column>
                            <el-table-column
                                    prop="schoolName"
                                    label="学校名称"
                                    :show-overflow-tooltip="true">

                            </el-table-column>
                            <el-table-column
                                    width="100"
                                    prop="orderCount"
                                    label="订单数">
                            </el-table-column>
                            <el-table-column
                                    width="120"
                                    prop="saleAmount"
                                    :show-overflow-tooltip="true"
                                    label="营业额">
                            </el-table-column>
                        </el-table>
                        <el-pagination
                                class="bi-pager"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageNo"
                                :page-size="pageSize"
                                layout="total, prev, pager, next"
                                :total="total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>

export default {
    name: "home",
    components: {  },
    data () {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 1*24*60*60*1000;
                },
            },
            timeTabList: [
                {id: 1, label: '昨天', checked: true},
                {id: 2, label: '近7天', checked: false},
                {id: 3, label: '近30天', checked: false},
                // {id: 4, label: '按周', checked: false},
                // {id: 4, label: '按月', checked: false},
                // {id: 5, label: '自定义', checked: false}
            ],
            hourData: {},
            // historyTimeRange: '',
            startDate: '',
            endDate: '',
            selectMonth: '', // 选择月份
            businessDetail: {}, //营业数据
            viewDetail: {}, // 流量分析
            schoolRanking: {}, // 学校排行
            popoverVisible: false,
            isMonthChecked: false,
            selectDate: '', // 自定义
            isDateChecked: false,
            popoverVisible1: false,
            loading: false,
            pageSize: 10,
            pageNo: 1,
            total: 0,
            tabName: '比前日'
        }
    },
    created() {
        this.getHourData();
        this.getHistoryData(1,0);

    },
    methods: {
        getValue(n1,n2) {
            if(n1 != n2){
                let n = (n1 - n2).toFixed(2);
                return Math.abs(n);
            }else{
                return '';
            }
        },
        getStyles(p) {
            let arr = p.toString().split('.');
            if(arr[1]){
                return `${arr[0]}<span class='f20' v-hyml=${arr[1]}></span>`
            }else{
                return p;
            }
        },
        getMonth() {
            if(!this.selectMonth || this.selectMonth.length == 0){
                this.$message.warning('请选择月份');
                return;
            }
            this.popoverVisible = false;
            this.isMonthChecked = true;
            this.isDateChecked = false;
            this.getHistoryData(4,3);
        },
        getDate() {
            if(!this.selectDate || this.selectDate.length == 0){
                this.$message.warning('请选择日期');
                return;
            }
            this.popoverVisible1 = false;
            this.isDateChecked = true;
            this.isMonthChecked = false;
            this.getHistoryData(5,4);
        },
        getHourData() {
            this.$api.post_bip(this.$apiUrl.commercialGdHourData, {}, (res) => {
                if(res.data && res.data.saleAmount){
                    if(res.data.saleAmount){
                        let saleAmount = res.data.saleAmount;
                        let arr = saleAmount.toString().split('.');
                        if(arr[1]){
                            res.data.saleAmountDecimal = arr[1];
                            res.data.saleAmount = arr[0];
                        }
                    }
                    if(res.data.incomeAmount){
                        let incomeAmount = res.data.incomeAmount;
                        let arr = incomeAmount.toString().split('.');
                        if(arr[1]){
                            res.data.incomeAmountDecimal = arr[1];
                            res.data.incomeAmount = arr[0];
                        }
                    }
                }
                this.hourData = res.data;
            }, err => {
                this.$message.warning(err.msg);
            })
        },
        getHistoryData(id,index) {
            this.timeTabList.forEach((item)=>{
                item.checked = false;
            })
            if(index < 3){
                this.timeTabList[index].checked = true;
                this.selectMonth = '';
                this.isMonthChecked = false;
                this.isDateChecked = false;
            }
            this.getTimeRange(id);
            this.loading = true;
            // this.getBusinessDetail(id);
        },
        getTimeRange(id) {
            let today = new Date();
            let yesterday = today.setDate(today.getDate() - 1);
            // today.setDate(today.getDate());
            switch (id) {
                case 1:
                    // 昨天
                    // let yesterday = today.setDate(today.getDate() - 1);
                    this.startDate = this.endDate = this.$utils.formatDate1(yesterday);
                    this.tabName = '比前日';
                    break;
                case 2:
                    // 近7天
                    let s1 = today.setDate(today.getDate() - 6);
                    this.startDate = this.$utils.formatDate1(s1);
                    this.endDate = this.$utils.formatDate1(yesterday);
                    this.tabName = '比上周';
                    break;
                case 3:
                    // 近30天
                    let s2 = today.setDate(today.getDate() - 29);
                    this.startDate = this.$utils.formatDate1(s2);
                    this.endDate = this.$utils.formatDate1(yesterday);
                    this.tabName = '比上月';
                    break;
                case 4:
                    // 按月
                    this.startDate = this.selectMonth + '-01';
                    let year = this.selectMonth.split('-')[0];
                    let month = parseInt(this.selectMonth.split('-')[1]);
                    this.endDate = this.selectMonth + '-' + this.getDaysInMonth(year,month);
                    this.tabName = '比上月';
                    break;
                case 5:
                    // 自定义
                    this.startDate = this.selectDate[0];
                    this.endDate = this.selectDate[1];
                    this.tabName = '比上时间段';
                    break;
            }
            this.getDetail();
        },
        getDetail() {
            // 营业额数据
            this.$api.post_bip(this.$apiUrl.commercialGdBusinessData, {startTime: this.startDate, endTime: this.endDate}, (res) => {
                this.loading = false;
                if(res.data.saleAmount){
                    let saleAmount = res.data.saleAmount;
                    let arr = saleAmount.toString().split('.');
                    if(arr[1]){
                        res.data.saleAmountDecimal = arr[1];
                        res.data.saleAmount = parseInt(arr[0]);
                    }
                }
                if(res.data.incomeAmount){
                    let incomeAmount = res.data.incomeAmount;
                    let arr = incomeAmount.toString().split('.');
                    if(arr[1]){
                        res.data.incomeAmountDecimal = arr[1].substring(0,2);
                        res.data.incomeAmount = parseInt(arr[0]);
                    }
                }
                if(res.data.averageSinglePerson){
                    let averageSinglePerson = res.data.averageSinglePerson;
                    let arr = averageSinglePerson.toString().split('.');
                    if(arr[1]){
                        res.data.averageSinglePersonDecimal = arr[1].substring(0,2);
                        res.data.averageSinglePerson = parseInt(arr[0]);
                    }
                }
                this.businessDetail = res.data;
            }, err => {
                this.$message.warning(err.msg);
            })
            // 流量分析
            this.$api.post_bip(this.$apiUrl.commercialGdViewData, {startTime: this.startDate, endTime: this.endDate}, (res) => {
                let data = res.data;
                let temp_data = []
                let other = {
                    clientType: "999",
                    enterCount: 0,
                    orderCount: 0,
                    orderCountPercentage: 0,
                    viewCount: 0,
                    viewShopPercentage: 0,
                }
                data.viewCountDetail.forEach(item => {
                    if (item.clientType == 4 || item.clientType == 5) {
                        other.enterCount += item.enterCount;
                        other.viewCount += item.viewCount;
                        other.orderCount += item.orderCount;
                    } else {
                        temp_data.push(item);
                    }
                })
                if (!other.viewCount) {
                    other.viewShopPercentage = 0;
                } else {
                    other.viewShopPercentage = Math.round((other.enterCount/other.viewCount) * 10000);
                    if (other.viewShopPercentage.toString().length > 5) {
                        let f = other.viewShopPercentage.toString().substr(5, 1);
                        other.viewShopPercentage = +(other.viewShopPercentage.toString().substr(0, 4));
                        if (f > 4) other.viewShopPercentage += 1;
                    }
                }

                if (!other.enterCount) {
                    other.orderCountPercentage = 0;
                } else {
                    other.orderCountPercentage = Math.round((other.orderCount/other.enterCount) * 10000);
                    if (other.orderCountPercentage.toString().length > 5) {
                        let f = other.orderCountPercentage.toString().substr(5, 1);
                        other.orderCountPercentage = +(other.orderCountPercentage.toString().substr(0, 4));
                        if (f > 4) other.orderCountPercentage += 1;
                    }
                }

                other.viewShopPercentage = other.viewShopPercentage / 10000;
                other.orderCountPercentage = other.orderCountPercentage / 10000;
                temp_data.push(other)
                data.viewCountDetail = temp_data;
                this.viewDetail = data;
                // this.viewDetail = res.data;
            }, err => {
                this.$message.warning(err.msg);
            })
            this.getSchoolRanking();
        },
        getSchoolRanking() {
            // 学校排行
            this.$api.post_bip(this.$apiUrl.commercialGdSchoolRanking, {startTime: this.startDate, endTime: this.endDate,pageNo: this.pageNo,pageSize: this.pageSize}, (res) => {
                this.schoolRanking = res.data;
                this.total = res.data.totalCount || 0;
            }, err => {
                this.$message.warning(err.msg);
            })
        },
        getDaysInMonth(year,month){
            // month = month + 1;
            switch (month) {
                case 1:
                case 3:
                case 5:
                case 7:
                case 8:
                case 10:
                case 12:
                    return 31;
                case 4:
                case 6:
                case 9:
                case 11:
                    return 30;
                case 2:
                    return ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) ? 29 : 28;
                default:
                    return 0;
            }
        },
        //切换每页显示条数操作
        handleSizeChange(val) {
            this.pageSize = val;
            this.getSchoolRanking();
        },
        //切换页码操作
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getSchoolRanking();
        }
    }

}
</script>

<style lang="scss" scoped>
    .pt24{
        padding-top: 24px;
    }
    .pl24{
        padding-left: 24px;
    }
    .c7{
        color: rgba(0, 0, 0, 0.65);
    }
    .container{
        margin: -15px;
        padding: 24px;
        background-color: #f5f5f5;
        min-height: 1400px;
    }
    h1{
        font-size: 16px;
        font-weight: 500;
        span{
            font-size: 14px;
            color: #666;
            margin-left: 16px;
        }
    }
    .card{
        width: 100%;
        background: #FFFFFF;
        border-radius: 4px;
        margin-bottom: 24px;
        .tag-name{
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.45);
            line-height: 22px;
            margin-right: 30px;
            &.checked{
                color: #3AA0FF;
            }
        }
        .number{
            font-size: 24px;
            font-family: HelveticaNeue;
            color: rgba(0, 0, 0, 0.85);
            line-height: 38px;
            margin-top: 5px;
        }
        .card-name{
            font-size: 16px;
            font-weight: 500;
            color: #262626;
            line-height: 24px;
            margin: 0 24px;
            padding: 16px 0;
            border-bottom: 1px solid #E8E8E8;
        }
        ul{
            padding: 24px;
            overflow: hidden;
            li{
                float: left;
                width: 163px;
            }
        }
    }
    .arrow-up{
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 6px solid #F5222D;
    }
    .arrow-down{
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 6px solid #52C41A;
    }

</style>






// WEBPACK FOOTER //
// home.vue?2efcca2a